import React, { useEffect, useState } from "react";
import HeroText from '../assets/herotext.png'
import HeroImage from '../assets/hero.png'
import HeroImageSecond from '../assets/how-it-works-scaled.png'
import FooterImage from '../assets/imageFooter.png'

import Apple from '../assets/apple-store.svg'
import Huawei from '../assets/huawei-store-badge.svg'
import Google from '../assets/googleplay.svg'

import image1 from '../assets/image1.png'
import image2 from '../assets/image2.png'
import image3 from '../assets/image4.png'
import image4 from '../assets/image3.png'

import chat from '../assets/icons8-chat-32.png'
import axios from "axios";

import { MobiSignin } from "../Firebase";

function LandingPage() {
    const [selectedImage, setSelectedImage] = useState(image1);
    const [loading, setLoading] = useState(false);
    const [ResetModal, setOpenReset] = useState(false);
    const [ResetLoader, setResetLoader] = useState(false);
    const [ResetPhone, setResetPhone] = useState("");
    const [ResetMessage, setResetmessage] = useState("");

    const [Phonenumber, setPhonenumber] = useState("");
    const [Password, setPassword] = useState("");
    const [Country, setCountry] = useState("");
    const [SigninError, setSigninError] = useState("");


    async function subscribe() {
        setLoading(true);

        try {
            const response = await fetch("https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry");
            const country = await response.text();
            window.location.href = `https://publisherads.click/?SMCampaign=f3aeaff8-ae65-4723-8c12-4fbb76bb72ed&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=${country}&themeid=3&portal=AiAvatar`;
        } catch (error) {
            console.error("Error fetching country:", error);
        } finally {
            setLoading(false);
        }
    }


    const handleImageChange = (step) => {
        const images = {
            1: image1,
            2: image2,
            3: image3,
            4: image4,
        };
        setSelectedImage(images[step]);
    };


    const redirectToStore = (platform) => {
        const urls = {
            ios: 'https://apps.apple.com/app/id1668151298',
            android: 'https://play.google.com/store/apps/details?id=avatar.ai.creator',
            huawei: 'https://appgallery.huawei.com/#/app/C109045405'
        };

        if (urls[platform]) {
            window.open(urls[platform], '_blank'); // Opens in a new tab
        }
    };

    function OpenResetModal() {
        setOpenReset(true)
    }

    function CloseResetModal() {
        setOpenReset(false)
    }


    function resetpass(phone) {
        setResetLoader(true)
        fetch(`http://apiv2.mobileartsme.com/resetpass?phonenumber=${phone}&IDService=2`)
            .then(res => res.json())
            .then(response => {

                setResetLoader(false)
                setResetmessage(response.result)
            })


    }

    async function Signin() {
        try {
            axios.get(`https://apiv2.mobileartsme.com/login?serviceid=2059&phonenumber=${Phonenumber}&password=${Password}&type=signin&country=${Country}`)
                .then(response => {
                    console.log(response.data)

                    if (response.data.Error != 0) {
                        setSigninError(response.data.Result)
                    } else {

                        if (response.data.Result.Status != 0) {
                            setSigninError(response.data.Result.Description)
                        } else {
                            setSigninError("");
                            window.location.href = `/Portal/index.html?jwt_token=${Phonenumber}`;

                        }
                    }
                })

        } catch {
            console.log("Invalid phone number or password")
        }
    }


    useEffect(() => {
        axios.get('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
            .then(response => {
                setCountry(response.data)
            })
    }, [])

    return (
        <div style={{ background: "black" }} >


            <section >

                <div  >
                    <div className='row' style={{width:'100%'}} >

                        <div data-aos="fade-down"
                            className='heroLeft py-7 col-lg-7 d-flex flex-column justify-content-center' >
                            <div >
                                <p style={{ fontSize: '2rem' }} >AI Avatar Creator</p>
                                <img src={HeroText} />
                                <p className="py-2" >Generate hundreds of personalized AIs. <br></br>
                                    Generated Avatars in four simple steps.</p>

                                <div className="mb-5 d-flex flex-row gap-3" >

                                    <a href="#download_Section"

                                        className="lp-btn download-button">Download Now
                                        <svg aria-hidden="true" class="e-font-icon-svg e-fas-download" fill="white" height={'18px'} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg>
                                    </a>

                                    <button
                                        onClick={() => subscribe()}
                                        className="lp-btn subscribe-button" >

                                        Subscribe
                                        <svg aria-hidden="true" class="e-font-icon-svg e-fab-cc-visa"
                                            width={'18px'} fill="white"
                                            viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"></path></svg>
                                    </button>

                                </div>
                                <a className="d-flex flex-row gap-3 align-items-center" style={{ color: 'white', cursor: 'pointer' }} 
                                href="#signinsection" >
                                    <span>Click Here to <span style={{color:"#FED501" , fontWeight:'700'}} >Signin</span></span>
                                    <svg aria-hidden="true" class="e-font-icon-svg e-fas-sign-in-alt"
                                        viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="white" height={"15px"}
                                    ><path d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"></path></svg>
                                </a>
                            </div>
                        </div>

                        <div className='col-lg-5' >
                            <img src={HeroImage}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                </div>


            </section >


            <section style={{
                backgroundImage: `url(${HeroImageSecond})`, backgroundSize: 'cover'
            }}>

                <div className='container py-7' >
                    <div className='row section_2' >

                        <div className='how-it-works-image col-lg-6' data-aos="fade-up">
                            <img src={selectedImage} alt="Step Illustration" style={{ height: '70%' }} />
                        </div>

                        <div className='col-lg-6 d-flex flex-column justify-content-center' data-aos="fade-up">
                            <h1 style={{ fontSize: '3.5rem' }}>How It Works?</h1>

                            <div className='d-flex flex-column gap-4'>
                                {[
                                    { step: 1, title: "Download the app", text: "Download the app now and start using its amazing features today!" },
                                    { step: 2, title: "Upload your photos", text: "Upload 10-20 photos of yourself in various environments and lighting." },
                                    { step: 3, title: "Train AI", text: "Our artificial intelligence will learn based on your photos." },
                                    { step: 4, title: "Create over 100 Avatars", text: "Create custom avatars based on your descriptions." }
                                ].map(({ step, title, text }) => (

                                    <div className='step' key={step} >
                                        <div>
                                            <h1>{step}. {title}</h1>
                                            <p>{text}</p>
                                        </div>
                                        <input
                                            type='radio'
                                            name="step"
                                            onChange={() => handleImageChange(step)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>



                    </div>
                </div>
            </section>




            <section id="download_Section">

                <div>
                    <div className='row'  style={{width:'100%'}} >

                        <div className='heroLeft py-7 col-lg-5 d-flex flex-column justify-content-center' data-aos="fade-up">

                            <div className="mb-5 loginForm" id="signinsection">
                                <h1 className="fs-1 text-light mb-3" >Sign on to access AI Avatars features</h1>
                                <input placeholder="Username" onChange={(e) => setPhonenumber(e.target.value)} />
                                <div className="d-flex gap-2 mt-1" >
                                    <input placeholder="Password" type="password" onChange={(e) => setPassword(e.target.value)} />
                                    <button className="lp-btn subscribe-button" onClick={() => Signin()} >Sign In</button>
                                </div>
                                <p className="pt-2 fs-4" style={{ cursor: 'pointer' }} onClick={() => OpenResetModal()} >Forgot Password ?</p>
                                <p style={{ color: 'red', fontSize: '1.5rem' }} >{SigninError}</p>
                            </div>

                            <div className="footerDiv" >
                                <h1 className="fs-2" >Create AI Generated Avatars</h1>

                                <p className="pt-2">Change your visual identity thanks to our AI avatar generator.
                                    Our easy to use avatar creator allows you to create custom avatars
                                    in minutes, with different styles to choice.</p>

                                <h3 className="pt-3 fs-2" >Generate now and let your creativity shine!</h3>

                                <div className="downloadSection pt-1 d-flex flex-row gap-3 flex-wrap" >
                                    <img onClick={() => redirectToStore('ios')} src={Apple} alt="Download on the App Store" />
                                    <img onClick={() => redirectToStore('android')} src={Google} alt="Get it on Google Play" />
                                    <img onClick={() => redirectToStore('huawei')} src={Huawei} alt="Download on Huawei AppGallery" />

                                </div>

                                <h3 className="mt-7 fs-2" >Get in touch with us</h3>
                                <h5 className="text-light d-flex flex-row gap-2 mt-2" style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/Contact'}>
                                    Contact Us
                                    <img style={{ width: '20px' }} src={chat} />
                                </h5>

                            </div>
                        </div>
                        <div className='col-lg-1' ></div>
                        <div className='col-lg-6' >
                            <img src={FooterImage}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                </div>


            </section>

            {ResetModal ? (
                <div className='resetModal loginForm' >
                    <div className='resetModalContent'>
                        <h3 className="fs-1" >Forgot your password?</h3>
                        <p className='mt-2 fs-3 text-dark'>We will send you an SMS with your new password</p>
                        <input className='resetinput mt-2' placeholder='Phone Number' onChange={(e) => setResetPhone(e.target.value)} />
                        <p className="mt-2 fs-5 text-dark" >{ResetMessage}</p>

                        <div className='d-flex flex-row justify-content-end align-items-center mt-4' >
                            <button style={{ background: 'white', border: '1px solid white', color: '#3859C5' }}
                                onClick={() => CloseResetModal()} >Cancel</button>

                            <button onClick={() => resetpass(ResetPhone)} >
                                {ResetLoader ? <div style={{ width: '20px', height: '20px', padding: '4px' }} className='loader' ></div> : "Submit"}

                            </button>

                        </div>
                    </div>
                </div>
            ) : ""}


        </div >
    )
}

export default LandingPage